import type { SignalStatus, SignalConfidence } from "@/data/mockBrandSignalsData";
import type { FilterColumn } from "@/components/shared/SearchFilterBar";

export const STATUS_BG: Record<SignalStatus, string> = {
  validated: "bg-[hsl(142_55%_90%)]",
  testing: "bg-[hsl(234_99%_93%)]",
  hypothesis: "bg-[hsl(185_55%_88%)]",
  refuted: "bg-destructive/15",
};

export const STATUS_LABELS: Record<SignalStatus, string> = {
  validated: "Validated",
  testing: "Testing",
  hypothesis: "Hypothesis",
  refuted: "Refuted",
};

export const NOISE_CONFIDENCES: SignalConfidence[] = ["low"];
export const ACTIONABLE_CONFIDENCES: SignalConfidence[] = ["medium", "high"];

export type SortField = "hypothesis" | "category" | "confidence" | "status" | "tests" | "source" | "updated";

export const SIGNAL_FILTER_COLUMNS: FilterColumn[] = [
  {
    id: "status",
    label: "Status",
    options: [
      { value: "validated", label: "Validated" },
      { value: "testing", label: "Testing" },
      { value: "hypothesis", label: "Hypothesis" },
      { value: "refuted", label: "Refuted" },
    ],
  },
  {
    id: "confidence",
    label: "Confidence",
    options: [
      { value: "high", label: "High" },
      { value: "medium", label: "Medium" },
      { value: "low", label: "Low" },
    ],
  },
  {
    id: "source",
    label: "Source",
    options: [
      { value: "ai", label: "Signal AI" },
      { value: "user", label: "Manual" },
    ],
  },
];
